export function LogoWordmark() {
  return (
    <a href="/" className="brand" aria-label="calendarfeedback.com home">
      <img src="/logo.svg" width={26} height={26} alt="" />
      <span>calendarfeedback</span>
    </a>
  )
}
